define('views/product-list-view',[
  'jquery',
  'utils/view',

  'connections/product-list-connection',

  'modules/product-filter',
  'modules/priceXhr',

  'settings'
], function($, View, ProductListConnection, ProductFilter, priceXhr, settings) {
  var ProductListView = (function() {
    function ProductListView() {
      this.filter = new ProductFilter($('#product-filter'));

      this.$container = $('.product-listing__container');
      this.$loaderCntr = $('.product-listing__loader-wrapper');
      this.$loaderHideClass = 'product-listing__loader-wrapper--hidden';
      this.$searchCntr = this.filter.container.find('.search-field');
      this.$totalCountCntr = $('.product-listing__header__count').find('em');
      this.$titleContainer = $('.product-listing__header__heading').find('h1');
      this.$loadMoreWrapper = $('.product-listing__scroll-loader-wrapper');
      this.$loadMoreButton = $(
        '.product-listing__scroll-loader-wrapper button'
      );
      this.$productListEmptyWrapper = $('.product-listing__empty');
      this.$orderCtr = $('#sort-order');
      this.$catalogBtn = $('.button.catalogue');
      this.isOutlet = $('#product-listing').data('outlet') === true;
      this.xhr = priceXhr.xhrList;
      this.scrollUpdateTriggerCount = 0;
      this.scrollUpdateTriggerPause = false;
    }

    this.loadMore = false;

    ProductListView.prototype.init = function() {
      this.addUpdateListener(this.$searchCntr, 'searchChanged');
      this.addUpdateListener(this.$orderCtr, 'change');
      this.addUpdateListener(this.filter.container, 'filterChanged');
      this.addUpdateListener(this.$loadMoreButton, 'click', true);
      this.addScrollUpdateListener();

      // get initial products
      this.updateProductList();
    };

    ProductListView.prototype.addScrollUpdateListener = function(callback) {
      var _this = this;

      $(window).on('scroll.infiniteProducts', function() {
        var scrollFromBottomOffset = 800;
        if (
          $(window).scrollTop() >
          $(document).height() - $(window).height() - scrollFromBottomOffset
        ) {
          if (_this.loadMore === true) {
            _this.loadMore = false;
            _this.updateProductList(true ? _this.getOffset() : 0);
          }
        }
      });
    };

    ProductListView.prototype.removeScrollUpdateListener = function() {
      $(window).off('scroll.infiniteProducts');
    };

    /**
     * Get latest successful search
     * @param {[type]} searchcriteria [description]
     */
    ProductListView.prototype.updatePdfButton = function() {
      var encodedSearchCriteria = encodeURIComponent(
        settings.productList + '?' + $.param(this.latestSearch)
      ).replace(/%25/g, '%');

      this.$catalogBtn.attr(
        'href',
        settings.productListPdf +
          '&latestsearch=' +
          encodedSearchCriteria +
          '&totalcount=' +
          this.$totalCountCntr.text()
      );
    };

    /**
     * Listens to events on provided element to run a new product list search
     *
     */
    ProductListView.prototype.addUpdateListener = function(
      $el,
      event,
      addOffset
    ) {
      var _this = this;
      $el.on(event, function() {
        _this.updateProductList(addOffset ? _this.getOffset() : 0);
      });
    };

    /**
     * Aborts all price view calls and previous filter calls. Without this, slow connection to network
     * or ERP will delay other ajax calls started by the user. This will make the site respond to new filter
     * selection much faster.
     */
    ProductListView.prototype.abortAllXhr = function() {
      for (var i = this.xhr.length - 1; i >= 0; i--) {
        if (this.xhr[i].readyState < 4) this.xhr[i].abort();
      }

      this.xhr = [];
    };

    /**
     * Sends input to the backend. Backend will return a new partial view. The view replaces or is
     * appended to the current view and events for visible prices and images will be fired.
     *
     * @param  {Bool} offset - If offset exist, this is a loadmore, so products will be appended instead of replacing.
     */
    ProductListView.prototype.updateProductList = function(offset) {
      var _this = this;
      var inputData = this.getInputParameters(offset);

      if (!offset) this.$loaderCntr.removeClass(this.$loaderHideClass);
      _this.$productListEmptyWrapper.hide();

      this.abortAllXhr();

      var xhr = ProductListConnection.getProductList(inputData);
      this.xhr.push(xhr);

      _this.$loadMoreWrapper.find('.loader').show();
      xhr
        .then(function(res) {
          // Successful search parameters saved for use in pdf creation.
          _this.latestSearch = inputData;
          _this.updatePdfButton();
          _this.$loadMoreWrapper.show();

          // Show loadMore-button if more products with this search exists.
          var $loadedProducts = $(res);
          var $campaign = $loadedProducts.filter('[data-category-capaign]');

          var $loadMore = $loadedProducts.filter('#loadmore');
          var totalCount = $loadMore.data('totalCount');

          if ($loadMore.data('loadMore') === 'True') {
            _this.loadMore = true;

            var remaining =
              totalCount - $loadMore.children().length - (offset || 0);
            var watched = totalCount - remaining;
            var progress = watched / totalCount;

            // Show progress bar (watched/total products)
            _this.$loadMoreWrapper.find('.watched').text(watched);
            _this.$loadMoreWrapper.find('.total').text(totalCount);
            _this.$loadMoreWrapper.find('.progress-bar__fill').css({ width: progress * 100 + '%' });
          } else {
            _this.loadMore = false;
            _this.$loadMoreWrapper[0].style.display = 'none';
          }

          // Update totalcount.
          _this.$totalCountCntr.text(
            $loadMore.data('totalCount')
          );

          if (totalCount === 0) {
            _this.$productListEmptyWrapper.show();
          }

          // Replace view if new search, append if loading more.
          if (offset > 0) {
            _this.$container.append($loadMore.children());
          } else {
            window.productCardAddToCart.resetMatrices(); // Product card bindings lost so resetting data.

            _this.$container.html([$campaign, $loadMore.children()]);
          }

          // Update scrollTriggerCount and check if scrollbinding should be paused/removed.
          // Triggers every 2nd update
          _this.scrollUpdateTriggerCount += 1;
          _this.scrollUpdateTriggerPause = _this.scrollUpdateTriggerCount % 2 == 0;
          if (_this.scrollUpdateTriggerCount % 2 == 0) {
            _this.removeScrollUpdateListener();

            _this.$loadMoreWrapper.find('.loader').hide();
            _this.$loadMoreWrapper.find('.button').show();
          } else {
            _this.$loadMoreWrapper.find('.loader').show();
            _this.$loadMoreWrapper.find('.button').hide();

            _this.addScrollUpdateListener();
          }
        })
        .always(function() {
          _this.$loaderCntr.addClass(_this.$loaderHideClass);

          // Update visible images and prices.
          window.LazyLoadInstance.update();
          window.updateVisiblePrices();
        });
    };

    /**
     * Gets all input parameters from the filter, order dropdown and search field
     */
    ProductListView.prototype.getInputParameters = function(offset) {
      var queryString = $.trim(this.$searchCntr.find('input').val());

      // Split categories from filters.
      var filters = $.extend({}, this.filter.getSeletectedFilters());
      var categories = filters.categories ? filters.categories.join(',') : null;
      delete filters.categories;
      var facets = JSON.stringify(filters);

      // Construct query parameters.
      var inputParams = {
        offset: offset || 0,
        facets: facets,
        orderBy: this.$orderCtr.val(),
        outlet: this.isOutlet
      };
      if (categories) inputParams.categories = categories;
      if (queryString) inputParams.q = queryString;

      return inputParams;
    };

    ProductListView.prototype.getOffset = function() {
      return this.$container.find('article.product').length;
    };

    return ProductListView;
  })();

  return View('ProductListing', function() {
    var plv = new ProductListView();

    plv.init();
  });
});

